import { Component } from '@angular/core';

@Component({
    selector: 'app-demo-layout',
    templateUrl: './demo-layout.component.html',
    styleUrls: ['./demo-layout.component.scss']
})
export class DemoLayoutComponent { }
